import { SET_INLINE_FILTER } from "../actions/actionTypes";

const initialState = {
  inlineFilterApiData: {},
};

export const widgetReducer = (state = initialState, { type, payload }) => {
  if (type === SET_INLINE_FILTER) {
    return {
      ...state,
      inlineFilterApiData: payload,
    };
  } else return initialState;
};
